import DeleteModal from '$tablet-app/src/app/components/DeleteModal';
import { palette, spacing } from '$tablet-app/src/app/theme';
import { Button, ButtonProps } from '@akin-home/buttons/native';
import React, { FC, useState } from 'react';
import { StyleSheet } from 'react-native';

export interface DeleteButtonProps extends ButtonProps {
  onConfirm: () => any;
  deleteModalProps?: {
    title?: string;
    subtitle?: string;
    confirmDeleteString?: string;
  };
  buttonText?: string;
}

const DeleteButton: FC<DeleteButtonProps> = (props) => {
  const {
    onConfirm,
    deleteModalProps = {},
    buttonText = 'Delete',
    ...rest
  } = props;

  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button
        icon="trash"
        size="medium"
        iconSize={20}
        variant="secondary"
        textStyle={styles.deleteButtonTextStyle}
        iconColor="red"
        onPress={() => setVisible(true)}
        {...rest}
      >
        {buttonText}
      </Button>

      <DeleteModal
        visible={visible}
        onCancel={() => setVisible(false)}
        title={
          deleteModalProps?.title ??
          'Are you sure you want to delete this item?'
        }
        subtitle={deleteModalProps?.subtitle ?? 'This cannot be undone.'}
      >
        <Button
          icon="trash"
          onPress={() => {
            setVisible(false);
            props.onConfirm();
          }}
          style={styles.confirmDeleteButtonStyle}
          textStyle={styles.confirmDeleteButtonTextStyle}
        >
          {deleteModalProps?.confirmDeleteString ?? 'Confirm Delete'}
        </Button>
      </DeleteModal>
    </>
  );
};

// Styles
const styles = StyleSheet.create({
  deleteButtonTextStyle: {
    color: 'red',
  },
  confirmDeleteButtonStyle: {
    width: '100%',
  },
  confirmDeleteButtonTextStyle: {
    textTransform: 'capitalize',
  },
  closeButton: {
    marginLeft: spacing[4],
    paddingHorizontal: spacing[4],
  },
  container: {
    alignItems: 'center',
    padding: 16,
  },
  desc: {
    fontSize: 18,
  },
  heading: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: spacing[4],
  },
  imageWrap: {
    alignItems: 'center',
    backgroundColor: palette.Red,
    borderRadius: 58,
    height: 116,
    justifyContent: 'center',
    width: 116,
  },
  textWrapper: {
    alignItems: 'center',
    marginBottom: spacing[5],
    marginTop: 56,
  },
  topButtons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
});

export default DeleteButton;
